type TrailDay = {
  date: string;
  rainMm: number;
  tempMaxC: number;
  windSpeedKmh: number;
  weatherCode: number;
};

type Props = {
  forecast: TrailDay[];
};

function classify(day: TrailDay): { label: string; colour: string } {
  if (day.rainMm > 10) return { label: "Avoid", colour: "bg-red-100 text-red-700" };
  if (day.rainMm > 3 || day.tempMaxC < 0) return { label: "Marginal", colour: "bg-amber-100 text-amber-700" };
  return { label: "Rideable", colour: "bg-emerald-100 text-emerald-700" };
}

export default function TrailForecastRow({ forecast }: Props) {
  return (
    <div className="flex gap-1.5 overflow-x-auto pb-2 scrollbar-thin">
      {forecast.map(day => {
        const { label, colour } = classify(day);
        const dayLabel = new Date(day.date + "T12:00:00").toLocaleDateString("en-GB", { weekday: "short" });
        return (
          <div key={day.date} className="flex-shrink-0 w-[72px] rounded-[10px] border border-border-light bg-white text-center px-1.5 py-2">
            <div className="text-[10px] font-semibold text-text-muted uppercase tracking-[0.5px]">{dayLabel}</div>
            <div className={`mx-0.5 mt-1 rounded-[6px] py-1 text-[10px] font-bold uppercase ${colour}`}>{label}</div>
            <div className="mt-1 text-[9px] text-text-muted">{day.rainMm.toFixed(0)}mm rain</div>
            <div className="text-[9px] text-text-muted">{day.tempMaxC.toFixed(0)}°C</div>
          </div>
        );
      })}
    </div>
  );
}
